<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/company/company-list"><span
            class="mdi mdi-arrow-left"></span></a> Company Details</h4>
    </div>

    <div class="card">
      <div class="card-body new-detail-page">
        <ngb-tabset #t="ngbTabset">
          <ngb-tab id="tab-selectbyid1" title="Company Details">
            <ng-template ngbTabContent>
              <form [formGroup]="registerForm">
                <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Company Information</h5>
                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Company Name:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CompanyName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Parent Company:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.ParentCompanyName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Company Type:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CompanyType}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row even">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Company Profile:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CompanyProfileName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Business Stream:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.BusinessStream}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Account Manager:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.UserName}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Category:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CategoryName}}
                          ({{comdata?.CategoryDescription}})
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Payment History:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.PaymentHistoryName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Financial Status:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.FinancialStatusName}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row even">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">
                        Supplier Deliver History:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.SupplierDeliveryHistory}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Key Account:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">
                          {{comdata?.KeyAccounts == false ? "No" : "Yes"}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Client Time:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.ClientTime}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <h5 class="mb-3 pb-2 border-bottom mt-4 text-green">General Information</h5>
                <div class="form-row even">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Country:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CountryName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">State:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.StateName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">City:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.CityName}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Map Location:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.MapLocation}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Landline:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Landline}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Mobile:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Mobile}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row even">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Fax:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Fax}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Email:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Email}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Website:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Website}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Address 1:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.AddressLine1}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Address 2:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.AddressLine2}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> PO Box:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.PostalCode}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row even">
                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Remark:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.Remarks}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Status Remark</h5>

                <div class="form-row odd">

                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Status:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.StatusName}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Remark:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{comdata?.StatusRemark}}</p>
                      </div>
                    </div>
                  </div>

                </div>

              </form>
            </ng-template>
          </ngb-tab>

          <ngb-tab id="tab-selectbyid2">
            <ng-template ngbTabTitle>Company Document</ng-template>
            <ng-template ngbTabContent>

              <div class="form-row">
                <div class="form-row mb-3 w-100 d-flex justify-content-end">
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6" *ngFor="let item of companydata; index as i;">

                  <div class="card shadow-sm rounded-0 border">
                    <div class="document-img-box">
                      <img src="{{url+item.UrlPath}}" alt="image" class="img-thumbnail company document-img">
                    </div>

                    <div ngbDropdown class="d-inline-block p-2 list-dropdown-box">
                      <a href="javascript:void(0);" class="card-link text-dark"><i class="mdi mdi-image mdi-24"></i>
                        {{ (item.FileName.length>12)? (item.FileName | slice:0:12)+'...':(item.FileName ) }}</a>
                      <span *ngIf="permission.Company_AttachmentDownload==1 || userRId==1">
                        <i class="mdi mdi-dots-vertical mdi-24 float-right" id="dropdownBasic1" ngbDropdownToggle></i>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class=" dropdown-menu-right">
                          <a href="javascript:void(0);" (click)="downloadModal(downloadConfirm,item)"> <button
                              ngbDropdownItem><i class="mdi mdi-cloud-download"></i> Download</button> </a>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</div>

<ng-template #downloadConfirm>
  <div class="modal-body text-center">
    <p>Do you want to Download {{filesname}}?</p>
    <button type="button" class="btn btn-info btn-sm" (click)="download(companydata.FileName); modalRef.hide();"
      [disabled]="delNameDel">Download</button>
    <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>